var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,10l-9,1a4.008,4.008,0,1,0,2.316.743l3.466-.385A4.5,4.5,0,1,0,21,10Z",
    transform: "translate(-8 -10)",
    fill: "#0a5078"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.5 12.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.5 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,37H9a1,1,0,0,1-1-1V29a1,1,0,0,1,1-1H25a1,1,0,0,1,1,1v7A1,1,0,0,1,25,37Z",
    transform: "translate(-8 -28)",
    fill: "#365788"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,38H13a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v3A1,1,0,0,1,19,38Z",
    transform: "translate(-12 -33)",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,34a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,34Z",
    transform: "translate(-32 -33)",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 23.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,38a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,38Z",
    transform: "translate(-32 -37)",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 25.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,42a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,42Z",
    transform: "translate(-32 -41)",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,38h-1a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,37.5,38Z",
    transform: "translate(-36 -33)",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,37l-5-3V29l5-3Z",
    transform: "translate(-44 -26)",
    fill: "#0a5078"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 12.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 13.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.5 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,37H13a1,1,0,0,1-1-1V33a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v3A1,1,0,0,1,19,37Z",
    transform: "translate(-12 -32)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,37h-5a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v2A.5.5,0,0,1,19.5,37Z",
    transform: "translate(-14 -34)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,33a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,33Z",
    transform: "translate(-32 -32)",
    fill: "#c80a50"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,37a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,37Z",
    transform: "translate(-32 -36)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,41a.5.5,0,1,1,.5-.5A.5.5,0,0,1,32.5,41Z",
    transform: "translate(-32 -40)",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,46v1.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5V46Z",
    transform: "translate(-16 -46)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.238 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.238,50l-.2.5-1.675,4.186A.5.5,0,0,1,15.9,55h-.923a.5.5,0,0,1-.464-.685L16.038,50.5l.2-.5Z",
    transform: "translate(-14.476 -50)",
    fill: "#0a5078"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.261,55h-.923a.5.5,0,0,1-.464-.314L30.2,50.5,30,50h2l.2.5,1.525,3.814A.5.5,0,0,1,33.261,55Z",
    transform: "translate(-30 -50)",
    fill: "#0a5078"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.8 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8,50h2l-.2.5h-2Z",
    transform: "translate(-17.6 -50)",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2,50.5h-2L30,50h2Z",
    transform: "translate(-30 -50)",
    fill: "#00325a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,46H26v.5H16Z",
    transform: "translate(-16 -46)",
    fill: "#dc9600"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,37h-1a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v4A.5.5,0,0,1,37.5,37Z",
    transform: "translate(-36 -32)",
    fill: "#0a5078"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5,37a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,1,0v12A.5.5,0,0,1,54.5,37Z",
    transform: "translate(-54 -24)",
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5,37H36V34h.5a.5.5,0,0,1,.5.5v2A.5.5,0,0,1,36.5,37Z",
    transform: "translate(-36 -34)",
    fill: "#00325a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/Step4.5df6a53f002aa45c43cd2c6bdc1b6d6c.svg";
export { ForwardRef as ReactComponent };